/**
 * A standing reminder that what is being drawn is private (SRS C8).
 *
 * Work on the teacher-only layer looks exactly like the rest on the teacher's own
 * screen — it has to, or she would not be seeing what she is actually drawing. So the
 * board says so instead, plainly and for as long as that layer is the one in hand.
 *
 * The mistake this prevents is the expensive one: writing the answers in front of the
 * class believing they cannot be seen.
 */

import { useBoardStore } from '../../board/store.js';

export interface PrivateLayerBadgeProps {
  /** False for anybody who has no teacher-only layer to be on (SRS D4). */
  readonly show: boolean;
}

export function PrivateLayerBadge({ show }: PrivateLayerBadgeProps) {
  const activeLayer = useBoardStore((state) => state.activeLayer);
  if (!show || activeLayer !== 'teacher') return null;

  return (
    <div className="pointer-events-none absolute left-4 top-4 z-10 rounded-md border border-warning bg-surface px-3 py-1 text-sm text-warning shadow-sm">
      Only you can see what you draw now
    </div>
  );
}
